// @ts-nocheck
import FeedbackToast from "./FeedbackToast";

export default function SuccessMessage({ message, subtitle, duration, onClose }) {
  return (
    <FeedbackToast
      type="success"
      message={message}
      subtitle={subtitle}
      duration={duration}
      onClose={onClose}
    />
  );
}
